import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AdjustmentsModule } from '../../modules/adjustments/AdjustmentsModule.tsx';

export function AdjustmentsRouteElement() {
  return (
    <ModuleContainer moduleID="analysis">
      <AdjustmentsModule />
    </ModuleContainer>
  );
}
